import React from 'react';
import BookFlightOptions from "./BookFlightOptions/BookFlightOptions";
import styles from '../SearchWidget.module.scss';
import FlightLegs from "./FlightLegs/FlightLegs";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import LoginForm from "../LoginForm/LoginForm";
import responsiveDefinitions from "../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";
import Stopover from "./Stopover/Stopover";

const BookFlight = ({userCardType, imagineMode, Styles, stopoverOutgoing, stopoverIncoming, stopoverExpanded, isRoundTrip}) => {

    const hideOutbound = stopoverOutgoing.disabledAirports.length >= 2;
    const hideInbound = stopoverIncoming.disabledAirports.length >= 2 || !isRoundTrip;
    const bothLegsHidden = Boolean(hideOutbound && hideInbound);
    const isStopoverOpen = Boolean(stopoverExpanded && !bothLegsHidden);

    const containerClasses = [styles.bookFlightContainer];
    if (isStopoverOpen) containerClasses.push(styles.scrollable);

    const needToAuthenticate = imagineMode && !userCardType;
    const isDesktop = Styles.matches(false, false);

    return (
        <div className={containerClasses.join(' ')}>
            {needToAuthenticate ? <LoginForm/> : <FlightLegs/>}
            {!needToAuthenticate && <Stopover/>}
            <BookFlightOptions display={isDesktop} classes={'sw-hidden-on-shrink'}/>
        </div>
    );
};


BookFlight.propTypes = {
    Styles: PropTypes.object,
    userCardType: PropTypes.string,
    imagineMode: PropTypes.bool,
    stopoverOutgoing: PropTypes.object,
    stopoverIncoming: PropTypes.object,
    stopoverExpanded: PropTypes.bool,
    isRoundTrip: PropTypes.bool,

};

BookFlight.defaultProps = {
    Styles: {},
    userCardType: '',
    imagineMode: false,
    stopoverOutgoing: {},
    stopoverIncoming: {},
    stopoverExpanded: false,
    isRoundTrip: false,
};

export default responsiveDefinitions(connect(state => ({
    userCardType: state.common.userCardType,
    imagineMode: state.flightCourse.imagineMode,
    stopoverOutgoing: state.flightCourse.stopover.outgoing,
    stopoverIncoming: state.flightCourse.stopover.incoming,
    stopoverExpanded: state.flightCourse.stopover.eligible,
    isRoundTrip: state.flightCourse.roundTrip === 'RETURN',
}))(BookFlight));
